function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef } from "react";
import { UI, DEFAULT_FONT, BuilderIcon } from "../../builderUiTheme";
import { generateHtml } from "../utils/helpers";
import LogoImage from "../../../assets/images/logo-new.png";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var toolbarStyles = "\n  .ws-toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 24px;\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    gap: 16px;\n    flex-wrap: nowrap;\n    flex-shrink: 0;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.02), 0 1px 2px 0 rgba(0, 0, 0, 0.04);\n    font-family: 'DM Sans', sans-serif;\n    position: relative;\n  }\n  \n  .ws-logo-container {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  .ws-actions-container {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    flex-wrap: nowrap;\n    flex: 1 1 0;\n    min-width: 0;\n    justify-content: flex-end;\n  }\n\n  .ws-viewport-container {\n    display: flex;\n    background: #f1f5f9;\n    border-radius: 99px;\n    padding: 3px;\n    border: 1px solid #e2e8f0;\n    align-items: center;\n    flex: 0 0 auto;\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 2;\n  }\n\n  .ws-viewport-btn {\n    border: none;\n    background: transparent;\n    color: #64748b;\n    padding: 6px 16px;\n    border-radius: 99px;\n    cursor: pointer;\n    font-family: 'DM Sans', sans-serif;\n    font-size: 13px;\n    font-weight: 500;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    line-height: 1;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n\n  .ws-viewport-btn svg {\n    display: block;\n    flex-shrink: 0;\n  }\n\n  .ws-viewport-btn:hover {\n    color: #0f172a;\n  }\n\n  .ws-viewport-btn.active {\n    background: #ffffff;\n    color: #0f172a;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);\n    font-weight: 600;\n  }\n\n  .ws-icon-btn {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    width: 36px;\n    height: 36px;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #475569;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    flex-shrink: 0;\n  }\n\n  .ws-icon-btn:hover:not(:disabled) {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n    color: #0f172a;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  }\n\n  .ws-icon-btn:active:not(:disabled) {\n    transform: translateY(0);\n  }\n\n  .ws-icon-btn:disabled {\n    color: #cbd5e1;\n    border-color: #f1f5f9;\n    cursor: not-allowed;\n    background: #ffffff;\n  }\n\n  .ws-btn-delete {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    color: #ef4444;\n    border-radius: 8px;\n    width: 36px;\n    height: 36px;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    flex-shrink: 0;\n  }\n  \n  .ws-btn-delete:hover {\n    background: #fef2f2;\n    border-color: #fca5a5;\n    color: #dc2626;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(220, 38, 38, 0.05);\n  }\n  \n  .ws-btn-delete:active {\n    transform: translateY(0);\n  }\n  \n  .ws-divider {\n    width: 1px;\n    height: 20px;\n    background: #e2e8f0;\n    margin: 0 6px;\n  }\n  \n  .ws-btn-exit {\n    background: #ffffff;\n    color: #475569;\n    height: 36px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 500;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    border: 1px solid #e2e8f0;\n    padding: 0 14px;\n    font-family: 'DM Sans', sans-serif;\n  }\n  \n  .ws-btn-exit:hover:not(:disabled) {\n    background: #fef2f2;\n    border-color: #fca5a5;\n    color: #dc2626;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(220, 38, 38, 0.05);\n  }\n  \n  .ws-btn-exit:active:not(:disabled) {\n    transform: translateY(0);\n  }\n  \n  .ws-btn-exit-icon {\n    width: 36px;\n    height: 36px;\n    padding: 0;\n  }\n  \n  .ws-btn-secondary {\n    background: #ffffff;\n    color: #475569;\n    height: 36px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 0 16px;\n    font-family: 'DM Sans', sans-serif;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    white-space: nowrap;\n    flex-shrink: 0;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    text-decoration: none;\n  }\n  \n  .ws-btn-secondary:hover:not(:disabled) {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n    color: #0f172a;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  }\n  \n  .ws-btn-secondary:active:not(:disabled) {\n    transform: translateY(0);\n  }\n  \n  .ws-btn-secondary.active {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n  }\n  \n  .ws-btn-primary {\n    background: linear-gradient(135deg, #1f2937, #111827);\n    color: #ffffff;\n    height: 36px;\n    border: none;\n    border-radius: 8px;\n    padding: 0 18px;\n    font-family: 'DM Sans', sans-serif;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    white-space: nowrap;\n    flex-shrink: 0;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    text-decoration: none;\n    box-shadow: 0 4px 12px rgba(17, 24, 39, 0.15);\n  }\n  \n  .ws-btn-primary:hover:not(:disabled) {\n    background: linear-gradient(135deg, #374151, #1f2937);\n    transform: translateY(-1px);\n    box-shadow: 0 6px 16px rgba(17, 24, 39, 0.25);\n  }\n  \n  .ws-btn-primary:active:not(:disabled) {\n    transform: translateY(0);\n    box-shadow: 0 2px 6px rgba(17, 24, 39, 0.15);\n  }\n  \n  .ws-btn-primary:disabled {\n    background: #e2e8f0;\n    color: #94a3b8;\n    cursor: not-allowed;\n    box-shadow: none;\n  }\n  \n  .ws-dropdown-menu {\n    position: absolute;\n    top: calc(100% + 6px);\n    right: 0;\n    min-width: 200px;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);\n    z-index: 50;\n    overflow: hidden;\n    padding: 6px;\n    animation: ws-dropdown-in 0.15s cubic-bezier(0.16, 1, 0.3, 1);\n  }\n  \n  @keyframes ws-dropdown-in {\n    from {\n      opacity: 0;\n      transform: translateY(4px) scale(0.98);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0) scale(1);\n    }\n  }\n  \n  .ws-dropdown-header {\n    padding: 8px 12px 6px;\n    font-family: 'DM Sans', sans-serif;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: #94a3b8;\n  }\n  \n  .ws-dropdown-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    text-align: left;\n    border: none;\n    background: transparent;\n    padding: 8px 12px;\n    cursor: pointer;\n    font-family: 'DM Sans', sans-serif;\n    font-size: 13px;\n    color: #334155;\n    border-radius: 6px;\n    transition: all 0.15s ease;\n    text-decoration: none;\n  }\n  \n  .ws-dropdown-item:hover {\n    background: #f1f5f9;\n    color: #0f172a;\n  }\n  \n  .ws-dropdown-item svg {\n    color: #64748b;\n    transition: color 0.15s ease;\n  }\n  \n  .ws-dropdown-item:hover svg {\n    color: #0f172a;\n  }\n\n  .ws-toolbar-label {\n    display: inline;\n  }\n\n  @media (max-width: 1280px) {\n    .ws-toolbar {\n      padding: 10px 14px;\n      gap: 10px;\n    }\n\n    .ws-logo-container {\n      flex: 0 1 auto;\n      gap: 10px;\n    }\n\n    .ws-actions-container {\n      flex: 0 1 auto;\n      gap: 6px;\n    }\n\n    .ws-viewport-container {\n      flex: 0 0 auto;\n    }\n\n    .ws-viewport-btn {\n      padding: 6px 10px;\n      gap: 0;\n    }\n\n    .ws-viewport-btn .ws-toolbar-label {\n      display: none;\n    }\n\n    .ws-divider {\n      margin: 0 2px;\n    }\n\n    .ws-btn-secondary,\n    .ws-btn-primary {\n      padding: 0 10px;\n    }\n  }\n\n  @media (max-width: 1100px) {\n    .ws-logo-container img {\n      max-width: 110px !important;\n    }\n\n    .ws-btn-secondary .ws-toolbar-label,\n    .ws-btn-primary .ws-toolbar-label {\n      display: none;\n    }\n\n    .ws-btn-secondary.ws-btn-has-label,\n    .ws-btn-primary.ws-btn-has-label {\n      width: 36px;\n      padding: 0;\n      justify-content: center;\n    }\n\n    .ws-btn-secondary .ws-toolbar-caret {\n      display: none;\n    }\n  }\n\n  @media (max-width: 900px) {\n    .ws-toolbar {\n      padding: 8px 10px;\n      gap: 8px;\n    }\n\n    .ws-logo-container img {\n      max-width: 96px !important;\n    }\n\n    .ws-viewport-btn {\n      padding: 6px 8px;\n      min-width: 34px;\n    }\n\n    .ws-actions-container .ws-divider {\n      display: none;\n    }\n  }\n";
export default function Toolbar(_ref) {
  var viewport = _ref.viewport,
    setViewport = _ref.setViewport,
    undo = _ref.undo,
    redo = _ref.redo,
    history = _ref.history,
    future = _ref.future,
    downloadPdfFile = _ref.downloadPdfFile,
    downloadPagedPdfFile = _ref.downloadPagedPdfFile,
    clearCanvas = _ref.clearCanvas,
    onSave = _ref.onSave,
    page = _ref.page,
    showToast = _ref.showToast,
    triggerConfirm = _ref.triggerConfirm,
    standalone = _ref.standalone,
    _ref$headerActions = _ref.headerActions,
    headerActions = _ref$headerActions === void 0 ? null : _ref$headerActions;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    saveMenuOpen = _useState2[0],
    setSaveMenuOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    downloadMenuOpen = _useState4[0],
    setDownloadMenuOpen = _useState4[1];
  var saveMenuRef = useRef(null);
  var downloadMenuRef = useRef(null);
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFlushing = _useState6[0],
    setIsFlushing = _useState6[1];
  var flushThen = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(navigate) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isFlushing) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            setIsFlushing(true);
            _context.prev = 3;
            if (!(typeof window.flushBuilderSave === "function")) {
              _context.next = 9;
              break;
            }
            _context.next = 7;
            return window.flushBuilderSave();
          case 7:
            _context.next = 12;
            break;
          case 9:
            if (!(typeof window.saveDesign === "function")) {
              _context.next = 12;
              break;
            }
            _context.next = 12;
            return window.saveDesign();
          case 12:
            _context.next = 20;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](3);
            console.error(_context.t0);
            showToast === null || showToast === void 0 ? void 0 : showToast("Could not save latest changes. Please try again.");
            setIsFlushing(false);
            return _context.abrupt("return");
          case 20:
            setIsFlushing(false);
            navigate();
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 14]]);
    }));
    return function flushThen(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (!saveMenuOpen && !downloadMenuOpen) {
      return undefined;
    }
    var handleClickOutside = function handleClickOutside(event) {
      if (saveMenuRef.current && !saveMenuRef.current.contains(event.target)) {
        setSaveMenuOpen(false);
      }
      if (downloadMenuRef.current && !downloadMenuRef.current.contains(event.target)) {
        setDownloadMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      return document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [saveMenuOpen, downloadMenuOpen]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("style", {
      dangerouslySetInnerHTML: {
        __html: toolbarStyles
      }
    }), /*#__PURE__*/_jsxs("div", {
      className: "ws-toolbar",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "ws-logo-container",
        children: [(standalone || (headerActions === null || headerActions === void 0 ? void 0 : headerActions.exitUrl)) && /*#__PURE__*/_jsx("button", {
          type: "button",
          disabled: isFlushing,
          onClick: function onClick() {
            var exitUrl = (headerActions === null || headerActions === void 0 ? void 0 : headerActions.exitUrl) || "/workspace";
            if (standalone && triggerConfirm) {
              triggerConfirm("Any unsaved draft changes will be stored locally. Go back to Workspace?", function () {
                window.location.href = exitUrl;
              });
              return;
            }
            if (typeof window.saveDesignAndExit === "function") {
              window.saveDesignAndExit();
              return;
            }
            flushThen(function () {
              window.location.href = exitUrl;
            });
          },
          className: "ws-btn-exit ".concat(!(headerActions !== null && headerActions !== void 0 && headerActions.exitUrl) ? "ws-btn-exit-icon" : ""),
          style: {
            opacity: isFlushing ? 0.7 : 1,
            cursor: isFlushing ? "wait" : "pointer"
          },
          children: headerActions !== null && headerActions !== void 0 && headerActions.exitUrl ? isFlushing ? "Saving..." : "Exit" : /*#__PURE__*/_jsx(BuilderIcon, {
            name: "exit",
            size: 20
          })
        }), /*#__PURE__*/_jsx("a", {
          href: "/",
          style: {
            display: "block",
            textDecoration: "none"
          },
          children: /*#__PURE__*/_jsx("img", {
            src: LogoImage,
            alt: "WillowSpace",
            style: {
              display: "block",
              maxWidth: 130,
              maxHeight: 32
            }
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "ws-viewport-container",
        children: [{
          id: "desktop",
          label: "Desktop"
        }, {
          id: "tablet",
          label: "Tablet"
        }, {
          id: "mobile",
          label: "Mobile"
        }].map(function (v) {
          return /*#__PURE__*/_jsxs("button", {
            type: "button",
            title: v.label,
            "aria-label": v.label,
            className: "ws-viewport-btn ".concat(viewport === v.id ? "active" : ""),
            onClick: function onClick() {
              setViewport(v.id);
              showToast === null || showToast === void 0 ? void 0 : showToast("Canvas resized to ".concat(v.id, " width"));
            },
            children: [v.id === "desktop" && /*#__PURE__*/_jsxs("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "2.2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: [/*#__PURE__*/_jsx("rect", {
                x: "2",
                y: "3",
                width: "20",
                height: "14",
                rx: "2",
                ry: "2"
              }), /*#__PURE__*/_jsx("line", {
                x1: "8",
                y1: "21",
                x2: "16",
                y2: "21"
              }), /*#__PURE__*/_jsx("line", {
                x1: "12",
                y1: "17",
                x2: "12",
                y2: "21"
              })]
            }), v.id === "tablet" && /*#__PURE__*/_jsxs("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "2.2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: [/*#__PURE__*/_jsx("rect", {
                x: "4",
                y: "2",
                width: "16",
                height: "20",
                rx: "2",
                ry: "2"
              }), /*#__PURE__*/_jsx("line", {
                x1: "12",
                y1: "18",
                x2: "12.01",
                y2: "18"
              })]
            }), v.id === "mobile" && /*#__PURE__*/_jsxs("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "2.2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: [/*#__PURE__*/_jsx("rect", {
                x: "5",
                y: "2",
                width: "14",
                height: "20",
                rx: "2",
                ry: "2"
              }), /*#__PURE__*/_jsx("line", {
                x1: "12",
                y1: "18",
                x2: "12.01",
                y2: "18"
              })]
            }), /*#__PURE__*/_jsx("span", {
              className: "ws-toolbar-label",
              children: v.label
            })]
          }, v.id);
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "ws-actions-container",
        children: [/*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: undo,
          disabled: !history.length,
          title: "Undo",
          className: "ws-icon-btn",
          children: /*#__PURE__*/_jsxs("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [/*#__PURE__*/_jsx("path", {
              d: "M3 7v6h6"
            }), /*#__PURE__*/_jsx("path", {
              d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13"
            })]
          })
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: redo,
          disabled: !future.length,
          title: "Redo",
          className: "ws-icon-btn",
          children: /*#__PURE__*/_jsxs("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [/*#__PURE__*/_jsx("path", {
              d: "M21 7v6h-6"
            }), /*#__PURE__*/_jsx("path", {
              d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7"
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "ws-divider"
        }), (headerActions === null || headerActions === void 0 ? void 0 : headerActions.mode) !== "template" && /*#__PURE__*/_jsxs("div", {
          ref: downloadMenuRef,
          style: {
            position: "relative"
          },
          children: [/*#__PURE__*/_jsx("button", {
            type: "button",
            onClick: function onClick() {
              return setDownloadMenuOpen(function (open) {
                return !open;
              });
            },
            title: "Download PDF",
            className: "ws-btn-secondary ".concat(downloadMenuOpen ? "active" : ""),
            style: {
              width: 36,
              height: 36,
              padding: 0,
              justifyContent: "center"
            },
            children: /*#__PURE__*/_jsxs("svg", {
              width: "18",
              height: "18",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: [/*#__PURE__*/_jsx("path", {
                d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
              }), /*#__PURE__*/_jsx("polyline", {
                points: "7 10 12 15 17 10"
              }), /*#__PURE__*/_jsx("line", {
                x1: "12",
                y1: "15",
                x2: "12",
                y2: "3"
              })]
            })
          }), downloadMenuOpen && /*#__PURE__*/_jsxs("div", {
            className: "ws-dropdown-menu",
            children: [/*#__PURE__*/_jsx("div", {
              className: "ws-dropdown-header",
              children: "Download PDF"
            }), /*#__PURE__*/_jsxs("button", {
              type: "button",
              className: "ws-dropdown-item",
              onClick: function onClick() {
                setDownloadMenuOpen(false);
                downloadPdfFile === null || downloadPdfFile === void 0 ? void 0 : downloadPdfFile();
              },
              children: [/*#__PURE__*/_jsxs("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                style: {
                  flexShrink: 0
                },
                children: [/*#__PURE__*/_jsx("path", {
                  d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                }), /*#__PURE__*/_jsx("polyline", {
                  points: "14 2 14 8 20 8"
                })]
              }), "Single Page"]
            }), /*#__PURE__*/_jsxs("button", {
              type: "button",
              className: "ws-dropdown-item",
              onClick: function onClick() {
                setDownloadMenuOpen(false);
                downloadPagedPdfFile === null || downloadPagedPdfFile === void 0 ? void 0 : downloadPagedPdfFile();
              },
              children: [/*#__PURE__*/_jsxs("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                style: {
                  flexShrink: 0
                },
                children: [/*#__PURE__*/_jsx("path", {
                  d: "M8 7H18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z"
                }), /*#__PURE__*/_jsx("path", {
                  d: "M6 17H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1"
                })]
              }), "Separate Pages"]
            })]
          })]
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: clearCanvas,
          title: "Clear Canvas",
          className: "ws-btn-delete",
          children: /*#__PURE__*/_jsxs("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [/*#__PURE__*/_jsx("polyline", {
              points: "3 6 5 6 21 6"
            }), /*#__PURE__*/_jsx("path", {
              d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
            })]
          })
        }), headerActions && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "ws-divider"
          }), headerActions.previewUrl && /*#__PURE__*/_jsxs("a", {
            href: headerActions.previewUrl,
            target: "_blank",
            rel: "noreferrer",
            onClick: function onClick(e) {
              e.preventDefault();
              var url = headerActions.previewUrl;
              flushThen(function () {
                window.open(url, "_blank", "noopener,noreferrer");
              });
            },
            className: "ws-btn-secondary ws-btn-has-label",
            title: "Preview",
            style: {
              opacity: isFlushing ? 0.7 : 1,
              pointerEvents: isFlushing ? "none" : "auto"
            },
            children: [/*#__PURE__*/_jsxs("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: [/*#__PURE__*/_jsx("path", {
                d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
              }), /*#__PURE__*/_jsx("circle", {
                cx: "12",
                cy: "12",
                r: "3"
              })]
            }), /*#__PURE__*/_jsx("span", {
              className: "ws-toolbar-label",
              children: isFlushing ? "Saving..." : "Preview"
            })]
          }), headerActions.mode === "template" ? /*#__PURE__*/_jsxs("button", {
            type: "button",
            disabled: isFlushing,
            onClick: function onClick() {
              if (typeof window.saveDesign === "function") {
                window.saveDesign();
              }
            },
            className: "ws-btn-primary ws-btn-has-label",
            title: "Save",
            children: [/*#__PURE__*/_jsxs("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: [/*#__PURE__*/_jsx("path", {
                d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
              }), /*#__PURE__*/_jsx("polyline", {
                points: "17 21 17 13 7 13 7 21"
              }), /*#__PURE__*/_jsx("polyline", {
                points: "7 3 7 8 15 8"
              })]
            }), /*#__PURE__*/_jsx("span", {
              className: "ws-toolbar-label",
              children: "Save"
            })]
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs("div", {
              ref: saveMenuRef,
              style: {
                position: "relative"
              },
              children: [/*#__PURE__*/_jsxs("button", {
                type: "button",
                onClick: function onClick() {
                  return setSaveMenuOpen(function (open) {
                    return !open;
                  });
                },
                className: "ws-btn-secondary ws-btn-has-label ".concat(saveMenuOpen ? "active" : ""),
                title: "Save",
                children: [/*#__PURE__*/_jsxs("svg", {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  strokeWidth: "2",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  children: [/*#__PURE__*/_jsx("path", {
                    d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                  }), /*#__PURE__*/_jsx("polyline", {
                    points: "17 21 17 13 7 13 7 21"
                  }), /*#__PURE__*/_jsx("polyline", {
                    points: "7 3 7 8 15 8"
                  })]
                }), /*#__PURE__*/_jsx("span", {
                  className: "ws-toolbar-label",
                  children: "Save"
                }), /*#__PURE__*/_jsx("svg", {
                  className: "ws-toolbar-caret",
                  width: "14",
                  height: "14",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  strokeWidth: "2.2",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  style: {
                    marginLeft: 2
                  },
                  children: /*#__PURE__*/_jsx("polyline", {
                    points: "6 9 12 15 18 9"
                  })
                })]
              }), saveMenuOpen && /*#__PURE__*/_jsxs("div", {
                className: "ws-dropdown-menu",
                children: [/*#__PURE__*/_jsxs("button", {
                  type: "button",
                  className: "ws-dropdown-item",
                  onClick: function onClick() {
                    setSaveMenuOpen(false);
                    if (typeof window.saveDesign === "function") {
                      window.saveDesign();
                    }
                  },
                  children: [/*#__PURE__*/_jsxs("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [/*#__PURE__*/_jsx("path", {
                      d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                    }), /*#__PURE__*/_jsx("polyline", {
                      points: "17 21 17 13 7 13 7 21"
                    }), /*#__PURE__*/_jsx("polyline", {
                      points: "7 3 7 8 15 8"
                    })]
                  }), "Save"]
                }), /*#__PURE__*/_jsxs("button", {
                  type: "button",
                  className: "ws-dropdown-item",
                  onClick: function onClick() {
                    setSaveMenuOpen(false);
                    if (typeof window.saveDesignAndExit === "function") {
                      window.saveDesignAndExit();
                    }
                  },
                  children: [/*#__PURE__*/_jsxs("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [/*#__PURE__*/_jsx("path", {
                      d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
                    }), /*#__PURE__*/_jsx("polyline", {
                      points: "16 17 21 12 16 7"
                    }), /*#__PURE__*/_jsx("line", {
                      x1: "21",
                      y1: "12",
                      x2: "9",
                      y2: "12"
                    })]
                  }), "Save & Exit"]
                }), headerActions.saveAsTemplateUrl && /*#__PURE__*/_jsxs("a", {
                  href: headerActions.saveAsTemplateUrl,
                  className: "ws-dropdown-item",
                  onClick: function onClick(e) {
                    e.preventDefault();
                    var url = headerActions.saveAsTemplateUrl;
                    setSaveMenuOpen(false);
                    flushThen(function () {
                      window.location.href = url;
                    });
                  },
                  children: [/*#__PURE__*/_jsxs("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [/*#__PURE__*/_jsx("rect", {
                      x: "3",
                      y: "3",
                      width: "18",
                      height: "18",
                      rx: "2",
                      ry: "2"
                    }), /*#__PURE__*/_jsx("line", {
                      x1: "9",
                      y1: "9",
                      x2: "15",
                      y2: "9"
                    }), /*#__PURE__*/_jsx("line", {
                      x1: "9",
                      y1: "13",
                      x2: "15",
                      y2: "13"
                    }), /*#__PURE__*/_jsx("line", {
                      x1: "9",
                      y1: "17",
                      x2: "13",
                      y2: "17"
                    })]
                  }), "Save as Template"]
                })]
              })]
            }), headerActions.shareUrl && /*#__PURE__*/_jsx("a", {
              href: headerActions.shareUrl,
              id: "share-proposal-new",
              "data-id": "shareProposal",
              onClick: function onClick(e) {
                e.preventDefault();
                var url = headerActions.shareUrl;
                flushThen(function () {
                  window.location.href = url;
                });
              },
              className: "ws-btn-primary",
              title: headerActions.shareLabel || "Share Contract",
              style: {
                opacity: isFlushing ? 0.7 : 1,
                pointerEvents: isFlushing ? "none" : "auto",
                width: 36,
                minWidth: 36,
                padding: 0,
                justifyContent: "center"
              },
              children: /*#__PURE__*/_jsxs("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [/*#__PURE__*/_jsx("circle", {
                  cx: "18",
                  cy: "5",
                  r: "3"
                }), /*#__PURE__*/_jsx("circle", {
                  cx: "6",
                  cy: "12",
                  r: "3"
                }), /*#__PURE__*/_jsx("circle", {
                  cx: "18",
                  cy: "19",
                  r: "3"
                }), /*#__PURE__*/_jsx("line", {
                  x1: "8.59",
                  y1: "13.51",
                  x2: "15.42",
                  y2: "17.49"
                }), /*#__PURE__*/_jsx("line", {
                  x1: "15.41",
                  y1: "6.51",
                  x2: "8.59",
                  y2: "10.49"
                })]
              })
            })]
          })]
        })]
      })]
    })]
  });
}